import { render, staticRenderFns } from "./rescheduleBooking.vue?vue&type=template&id=1b0e2be7&"
import script from "./rescheduleBooking.vue?vue&type=script&lang=js&"
export * from "./rescheduleBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports